import { render } from "./PluginsPage.vue?vue&type=template&id=183bc817&scoped=true"
import script from "./PluginsPage.vue?vue&type=script&lang=js"
export * from "./PluginsPage.vue?vue&type=script&lang=js"

import "./PluginsPage.vue?vue&type=style&index=0&id=183bc817&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183bc817"]])

export default __exports__